import { CountriesException } from '@/domain/statics/repository/contract/exception/CountriesException'

export class CountriesEndpointsServerException extends CountriesException {

}
